import { z } from 'zod'

export const userSchema = z.object({
  id: z.string().ulid(),
  email: z.string().email(),
  name: z.string().min(1),
  avatar_url: z.string().url().nullable().optional(),
  tenant_id: z.string().nullable().optional(),
  is_platform_admin: z.number().int(),
  is_active: z.number().int(),
  last_login_at: z.string().datetime().nullable().optional(),
  created_at: z.string().datetime(),
  created_by: z.string().nullable().optional(),
  updated_at: z.string().datetime(),
  updated_by: z.string().nullable().optional(),
  deleted_at: z.string().datetime().nullable().optional(),
  deleted_by: z.string().nullable().optional(),
})

export const userPublicSchema = z.object({
  id: z.string().ulid(),
  email: z.string().email(),
  name: z.string().min(1),
  avatar_url: z.string().url().nullable().optional(),
  tenant_id: z.string().nullable().optional(),
  is_platform_admin: z.number().int(),
  is_active: z.number().int(),
  last_login_at: z.string().datetime().nullable().optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
})

export const sessionSchema = z.object({
  id: z.string().ulid(),
  user_id: z.string().ulid(),
  tenant_id: z.string().ulid().optional(),
  company_id: z.string().ulid().optional(),
  expires_at: z.string().datetime(),
  created_at: z.string().datetime(),
})

export const jwtPayloadSchema = z.object({
  sub: z.string(), // user_id
  email: z.string().email(),
  tenant_id: z.string().optional(),
  company_id: z.string().optional(),
  roles: z.array(z.string()).optional(),
  iat: z.number(),
  exp: z.number(),
})

export const loginInputSchema = z.object({
  email: z.string().email('อีเมลไม่ถูกต้อง'),
  password: z.string().min(8, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร'),
})

export const signupInputSchema = z.object({
  email: z.string().email('อีเมลไม่ถูกต้อง'),
  password: z.string().min(8, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร'),
  name: z.string().min(1, 'กรุณากรอกชื่อ-นามสกุล'),
})

export const tenantMembershipSchema = z.object({
  tenant_id: z.string().ulid(),
  tenant_name: z.string(),
  tenant_slug: z.string(),
  role: z.string(),
  is_owner: z.boolean(),
  joined_at: z.string().datetime(),
})
